export const SMART_RTP_TABS = [
  { key: "dashboard", label: "Dashboard", path: "/smart-rtp/dashboard" },
  { key: "games", label: "Games", path: "/smart-rtp/games" },
  { key: "orders", label: "Orders", path: "/smart-rtp/orders" },
  { key: "winners", label: "Winners", path: "/smart-rtp/winners" },
  { key: "big-prize-monitor", label: "Big Prize", path: "/smart-rtp/big-prize-monitor" },
  { key: "predict", label: "Predict", path: "/smart-rtp/predict-distribution" },
  { key: "reports", label: "Reports", path: "/smart-rtp/reports" },
  { key: "analytics", label: "Analytics", path: "/smart-rtp/analytics" },
  { key: "audit-logs", label: "Audit Logs", path: "/smart-rtp/audit-logs" },
  { key: "runtime", label: "Runtime", path: "/smart-rtp/runtime" },
];

export const SMART_RTP_PERMISSION = "smartRtp";

export const AID_STATUS_TABS = [
  { label: "All", value: "" },
  { label: "Active", value: "A" },
  { label: "Inactive", value: "I" },
];

export const ORDER_STATUS_TABS = [
  { label: "All", value: "" },
  { label: "Success", value: "Success" },
  { label: "Pending", value: "Pending" },
  { label: "Cancel", value: "Cancel" },
  { label: "Failed", value: "Failed" },
];

export const BIG_PRIZE_MONITOR_SCOPE_TABS = [
  { label: "Game Settings", value: "game" },
  { label: "Global Settings", value: "global" },
];

export const BIG_PRIZE_FILTER_TYPES = [
  { label: "-- Choose filter --", value: "" },
  { label: "Analyzer (all sections)", value: "analyzer" },
  { label: "All active users", value: "all_active" },
  { label: "No big prize winners", value: "no_big_prize_winners" },
  { label: "Top sellers", value: "top_sellers" },
  { label: "Medium sellers", value: "medium_sellers" },
  { label: "Low sale shops", value: "low_sale_shops" },
  { label: "Low RTP shops", value: "low_rtp_shops" },
];

export const POOL_STATUS_TABS = [
  { label: "All", value: "" },
  { label: "Active", value: "Active" },
  { label: "Frozen", value: "Frozen" },
  { label: "Closed", value: "Closed" },
];

export const WINNER_SEARCH_OPTIONS = [
  { value: "order_no", label: "Order number" },
  { value: "seller.pos_number", label: "Seller POS" },
  { value: "seller.mobile", label: "Seller Mobile" },
  { value: "seller.store_name", label: "Seller Store Name" },
  { value: "game_title", label: "Campaign Title" },
];

export const WINNER_SEARCH_NUMERIC_FIELDS = ["seller.mobile", "seller.pos_number"];

export const REDEEM_STATUS_TABS = [
  { label: "All", value: "" },
  { label: "Pending", value: "Pending" },
  { label: "Redeemed", value: "Redeemed" },
  { label: "Expired", value: "Expired" },
  { label: "Office Claim", value: "OfficeClaim" },
  { label: "Cancelled", value: "Cancelled" },
];

export const REPORT_STATUS_TABS = [
  { label: "All", value: "" },
  { label: "Ready", value: "Ready" },
  { label: "Stale", value: "Stale" },
  { label: "Building", value: "Building" },
];

export const RUNTIME_STATUS_TABS = [
  { label: "All", value: "" },
  { label: "INFO", value: "INFO" },
  { label: "WARN", value: "WARN" },
  { label: "ERROR", value: "ERROR" },
  { label: "CRITICAL", value: "CRITICAL" },
];
